import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import blogData from "../../Data/blogData";
import { Link } from "react-router-dom";

const BlogSection = () => {
  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    setBlogs(blogData);
  }, []);

  // Slider settings
  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 1000,
    autoplay: true,
    autoplaySpeed: 5000,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <section
      className="space"
      data-bg-src="/assets/img/update1/bg/blog_bg_2.png"
      id="blog-sec"
    >
      <div className="container">
        <div className="title-area text-center">
          <span className="sub-title6 justify-content-center">
            <span className="shape left">
              <span className="dots"></span>
            </span>
            LATEST BLOGS
            <span className="shape right">
              <span className="dots"></span>
            </span>
          </span>
          <h2 className="sec-title">Latest News & Feeds</h2>
        </div>

        <Slider {...settings} className="slider-shadow th-carousel">
          {blogs.map((post) => (
            <div key={post.id} className="col-md-6 col-xl-4 hh">
              <div className="blog-card">
                <div className="blog-img">
                  <img src={post.image} alt="blog" />
                </div>
                <div className="blog-content">
                  <div className="blog-meta">
                    <Link className="author" to="">
                      <img
                        src={post.authorImage}
                        alt="author"
                        style={{ width: "30px", height: "30px" }}
                      />
                      {post.author}
                    </Link>
                    <Link>
                      <i className="fal fa-calendar-days"></i>
                      {post.date}
                    </Link>
                  </div>
                  <h3 className="box-title">
                    <Link to={`/blog/blog-details/${post.id}`}>
                      {post.title}
                    </Link>
                  </h3>
                  <p className="blog-text">
                    {post.description.slice(0, 100)}...
                  </p>
                  <Link
                    to={`/blog/blog-details/${post.id}`}
                    className="link-btn style3"
                  >
                    Read More <i className="fas fa-arrow-right"></i>
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default BlogSection;
